import { Shadow, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, Skeleton as NativeBaseSkeleton } from 'native-base';
import React from 'react';

import { ComponentBreakpoint } from '../../../constants';

import { Desktop } from './desktop';
import { Mobile } from './mobile';

export interface SkeletonProps {
  viewportType: ComponentBreakpoint;
  renderCount: number;
}

export const Skeleton: React.FC<SkeletonProps> = ({ viewportType, renderCount }) => {
  const ResponsiveSkeleton = useBreakpointValue({
    base: <Mobile />,
    sm: <Desktop viewportType={viewportType} />,
  });

  const isTablet = useBreakpointValue({ base: true, lg: false });

  return (
    <VStack space={Spacing['inline.xxxs']}>
      {Array.from({ length: renderCount }).map((_, index) => (
        <Shadow level={2} borderRadius={BoxRadius.sm} key={String(index)}>
          {isTablet && (
            <VStack
              px={Spacing['inline.xxxs']}
              pt={Spacing['inline.xxxs']}
              py={{ base: 0, sm: Spacing['inline.xxxs'] }}
              space={Spacing['inline.xxxs']}>
              <HStack alignItems="center" w={'full'} justifyContent="space-between">
                <NativeBaseSkeleton
                  display={{ base: 'unset', lg: 'none' }}
                  w="30%"
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
                <NativeBaseSkeleton
                  display={{ base: 'unset', lg: 'none' }}
                  w="30%"
                  h={Typography['fontsize.md']}
                  borderRadius={BoxRadius.sm}
                  endColor={Color['brand.primary.lightest']}
                />
              </HStack>
              <Box h={0.5} display={{ base: 'unset', lg: 'none' }} bg="neutral.lightest" />
            </VStack>
          )}
          <HStack
            py={Spacing['inline.xxxs']}
            alignItems="center"
            borderRadius={BoxRadius.sm}
            pl={{ base: 0, sm: Spacing['inline.xxxs'] }}
            justifyContent={'center'}>
            {ResponsiveSkeleton}
          </HStack>
        </Shadow>
      ))}
    </VStack>
  );
};
